import React from "react";
import { useNotification } from "./NotificationProvider";

import "./Notification.css";

const NotificationDisplay: React.FC = () => {
  const { notifications } = useNotification();

  return (
    <div className="notification-message">
      <div className="notification-container">
        {notifications.map(({ id, message, type }) => (
          <div className="notification-item">
            <span
              key={id}
              style={{
                backgroundColor:
                  type === "error"
                    ? "#E62A2A"
                    : type === "warning"
                    ? "#fff3cd"
                    : "#d4edda",
                color:
                  type === "error"
                    ? "#FFFFFF"
                    : type === "warning"
                    ? "#856404"
                    : "#155724",
              }}
            >
              {message}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationDisplay;
